module.exports = __webpack_public_path__ + "static/media/chart-ico.5d5b9a31.svg";